import { useMutation } from 'react-query';
import { authFetch } from '../../../../CommonUtils/authFetch';
import { queryClient } from '../../../../../config/queryClient';
import { queryKeys } from './queryKeys';
import { AssetBucketingDTO } from './useAssetBucketQuery';

const resetAssetBuckets = (): Promise<AssetBucketingDTO> => {
  return authFetch('/Adviser/AssetBucketing/ResetAdviserLayout', {
    method: 'POST',
  });
};

export const useResetAdvisorAssetBucketsMutation = () => {
  return useMutation(resetAssetBuckets, {
    onSuccess: assetBuckets => {
      queryClient.setQueryData(queryKeys.advisorAssetBucket(), assetBuckets);
    },
  });
};
